/* © CNES */
import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { NavigateFunction } from 'react-router-dom';
import { getItemAvailability, getItemsAvailabilities } from './Items';

const QUERY_KEY = 'ItemAvailability';

/**
 * Interface for searchItems parameters.
 */
interface QueryItemAvailabilityModel {
  productId: string;
}

/**
 * Interface for searchItems parameters.
 */
export interface QueryItemsAvailabilitiesModel {
  availability: {
    href: string;
    endpointURL: string;
  }[];
}

/**
 * UseQuery synthax to call getItemAvailability from regards.
 * @param queryParams query Params.
 * @param navigate function to trigger navigation when error is returned.
 * @returns UseQueryResult.
 */
export const useGetItemAvailability = (
  queryParams: QueryItemAvailabilityModel,
  navigate: NavigateFunction,
  setError400: Function
) => {
  return useQuery({
    queryKey: [QUERY_KEY, queryParams, navigate, setError400],
    queryFn: getItemAvailability,
    refetchOnWindowFocus: false,
    enabled: !!queryParams?.productId,
    onError: (err: AxiosError) => {
      console.error(
        `product ${queryParams.productId} availibility request failed with error :  ${err}`
      );
    },
  });
};

/**
 * UseQuery synthax to call getItemAvailability from regards.
 * @param queryParams query Params.
 * @param navigate function to trigger navigation when error is returned.
 * @param setError400
 * @returns UseQueryResult.
 */
export const useGetItemsAvailabilities = (
  queryParams: QueryItemsAvailabilitiesModel
) => {
  return useQuery({
    queryKey: [QUERY_KEY, queryParams],
    queryFn: getItemsAvailabilities,
    refetchOnWindowFocus: false,
    enabled: !!queryParams?.availability?.length,
    onError: (err: AxiosError) => err,
  });
};
